export default __webpack_public_path__ + "static/media/1_0098.0c67f5d5.webp";